import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './App.css';
import NotFoundPage from './pages/notFoundPage/notFoundPage';
import DashboardPage from './pages/dashboardPage/dashboardPage';
import ChatBotPage from './pages/chatBotPage/chatBotPage';
import Login from './pages/loginPage/Login';
import SignIn from './pages/signInPage/SignIn';
import CommunityPage from './pages/communityPage/communityPage';
import Onboarding from './pages/onboarding/Onboarding';
// import RAG from './components/rag/RAG'

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReportPage from './pages/reportPage/reportPage';
import ProfilePage from './pages/profilePage/profilePage';
import SchedulePage from './pages/schedulePage/schedulePage';
import SplashScreen from './pages/splashScreenpage/SplashScreen';
import Level from './pages/level/Level';
import FileUpload from './pages/uploadSensorData/UploadFile';
import VirtualNursePage from "./pages/virtualNursePage/virtualNursePage"
import PersonlizedSearch from "./pages/personlizedSearchPage/personlizedSearchPage";

function App() {
  return (
    <>
      <ToastContainer style={{ height: '50vh' }} /> 
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<DashboardPage />}/>
        <Route path='/login' element={<Login />}/>
        <Route path='/signup' element={<SignIn />}/>
        <Route path='/chatbot' element={<ChatBotPage />}/>
        <Route path='/community' element={<CommunityPage />}/>
        <Route path='/report' element={<ReportPage />}/>
        <Route path='/schedule' element={<SchedulePage />}/>
        <Route path='/profile' element={<ProfilePage />}/>
        {/* <Route path='/rag' element={<RAG />}/> */}
        <Route path='/onboarding' element={<Onboarding />}/>
        <Route path='/splashscreen' element={<SplashScreen />}/>
        <Route path='/level' element={<Level/>}/>
        <Route path='/uploadfile' element={<FileUpload/>}/>
        <Route path='/nurse' element={<VirtualNursePage/>}/>
        <Route path='/psearch' element={<PersonlizedSearch/>}/>
        <Route path='*' element={<NotFoundPage />}/>
      </Routes>
    </BrowserRouter>
    </>
  );
}

export default App;
